<template>
  <div class="segment">

    <template v-if="segment.length > 0">
      <div :style="{width:attr.witdh,left:attr.left}" class="segment-selected"></div>
    </template>

    <template v-for="(i,index) of options" :key="index">
      <div :class="{'segment-item-active':index === seletced}"
           :ref="(dom) => collection(dom,index)"
           class="segment-item"
           @click="seletced = index">
        {{ i }}
      </div>
    </template>

  </div>
</template>

<script setup>

import {computed, ref} from "vue";

const props = defineProps(['options', 'active']);
const emit = defineEmits(['update:active']);

/* 被选的segment */
const seletced = computed({
  get() {
    return props.active;
  },
  set(value) {
    emit('update:active', value);
  }
});

/* segment的dom */
const segment = ref([]);
const collection = (dom, index) => {
  segment.value[index] = dom;
}

/* 同步被选 */
const attr = computed(() => {
  const node = segment.value[seletced.value];
  return {
    left: node.offsetLeft + "px",
    witdh: node.offsetWidth + 'px'
  }
})

</script>

<style lang="scss" scoped>

.segment {
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 3px;
  line-height: 1.56;
  color: $text-color-5;
  background-color: #f5f5f5;

  .segment-selected {
    position: absolute;
    border-radius: inherit;
    background-color: white;
    transition: left 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    top: 3px;
    height: calc(100% - 6px);
    z-index: 1;
  }

  .segment-item {
    position: relative;
    z-index: 2;
    border-radius: inherit;
    background-color: transparent;
    min-height: 36px;
    line-height: 36px;
    padding: 0 11px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:hover {
      background-color: rgba(0, 0, 0, 0.06);
      color: $heading-color;
    }
  }


  .segment-item-active {
    &:hover {
      background-color: transparent;
    }
  }

}

</style>
